import { useOptimisticMutation } from "../hooks/useOptimisticMutation";
import { upsertMatchesSuspensions } from "@/api/sportEventsNew";
import { SportEventsNewQueryKeys } from "@/tanstackQuery/queries/sportEventsNew";
import type {
  UpsertMatchSuspensionsParams,
  MatchSuspensionsEditorResponse,
} from "@/types/ApiResponses/SportEvent";

export const useUpsertMatchesSuspensions = (
  feedType: string,
  sportType?: string,
  targetUsername?: string,
  page?: number,
  pageSize?: number,
  search?: string
) => {
  // Must mirror useMatchesSuspensions' key exactly (incl. search) so the
  // optimistic update lands on the page the user is currently viewing.
  const queryKey = [
    SportEventsNewQueryKeys.MatchSuspensions,
    feedType,
    sportType,
    targetUsername,
    page,
    pageSize,
    search,
  ];

  return useOptimisticMutation<
    UpsertMatchSuspensionsParams,
    MatchSuspensionsEditorResponse
  >({
    queryKey,
    mutationFn: upsertMatchesSuspensions,
    optimisticUpdate: (variable, oldData) => {
      if (!oldData) return oldData;

      const newSuspensions = { ...oldData.suspensions };
      for (const s of variable.suspensions) {
        const key = s.providerId + "|" + s.matchId;
        if (s.active) {
          newSuspensions[key] = { id: s.matchId, active: s.active } as any;
        } else {
          delete newSuspensions[key];
        }
      }

      return { ...oldData, suspensions: newSuspensions };
    },
    updateOptions: { exactQueryKey: true, preventRefetchOnSettled: true },
  });
};
